<!--更多职位列表图片块-->
<template>
    <div class="imgBlock">
        <ul>
            <li v-for="(item, index) in imgList" :key="index">
                <a @click="open(item.href)">
                    <img :src="logoHandle(item.src)" :title="item.name"/>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
    import {getJobImgList} from '@/api/index';

    export default {
        name: "ImgBlock",
        data() {
            return {
                imgList: []
            };
        },
        created() {
            getJobImgList().then((res) => {
                this.imgList = res.data ? res.data.images : [];
            })
        },
        computed: {
            logoHandle() {
                return function (file) {
                    let imagePath = encodeURI(file);
                    return `/files?imagePath=${imagePath}`;
                }
            },
        },
        methods: {
            open(url) {
                window.open(url);
            }
        }
    }
</script>
<style scoped>
    .imgBlock ul li a {
        cursor: pointer
    }
</style>
